import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ScreeningRecord, ScreeningResult } from "../../models/Interfaces";
import getIzProvider from "../../models/providers/IzProviders";
import "../immunizations/events.css";
import "./events.css";
import ScreeningEventCard from "../../components/ScreeningEventCard";
import { useTranslation } from "react-i18next";
interface EventLocationState {
  screening?: ScreeningRecord;
  screeningResult?: ScreeningResult;
}

function ScreeningFaq() {
  const { state } = useLocation();
  const { screening } = (state as EventLocationState) || {};

  const { t } = useTranslation();
  const provider = screening?.izProviderKey ? getIzProvider(screening.izProviderKey, t) : undefined;
  return (
    <div className="p-4 event-card flex flex-col gap-1 max-md:bg-form max-md:text-white screening-faq">
      <h2 className="font-extrabold text-xl text-center">
        {t(`screening.lead_info_section_title`)}
      </h2>
      <div className="">
        <h2 className="font-extrabold text-center text-lg">{t(`screening.lead_info_title_1`)}</h2>
        <div className="ml-4">
          <ul>
            <li>
              <p>{t(`screening.lead_info_section_1_1`)}</p>
            </li>
          </ul>
        </div>
      </div>

      <div className="">
        <h2 className="font-extrabold text-center text-lg">{t(`screening.lead_info_title_2`)}</h2>
        <div className="ml-4">
          <ul>
            <li>
              <p>{t(`screening.lead_info_section_2_1`)}</p>
            </li>
            <li>
              <p>{t(`screening.lead_info_section_2_2`)}</p>
            </li>
          </ul>
        </div>
      </div>

      <div className="">
        <h2 className="font-extrabold text-center text-lg">{t(`screening.lead_info_title_3`)}</h2>
        <div className="ml-4">
          <ul>
            <li>
              <p>{t(`screening.lead_info_section_3_1`)}</p>
            </li>
            <li>
              <p>
                {t(`screening.lead_info_section_3_2a`)}
                <span className="has-text-weight-bold">
                  {t(`screening.lead_info_section_3_2b`)}
                </span>
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div className="">
        <p>{t(`screening.lead_info_section_footer_1`)}</p>
        <br />
        <p>
          {t(`screening.lead_info_section_footer_2`)}
          {provider && (
            <a href={provider.screeningResultLink} style={{ fontSize: `0.90rem` }}>
              {provider.screeningResultLink}
            </a>
          )}
        </p>
      </div>
    </div>
  );
}

export default function ScreeningEvents() {
  const { state } = useLocation();
  const { screening, screeningResult } = (state as EventLocationState) || {};
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2 max-md:px-4 max-md:pb-20 max-md:pt-6">
      <p className="text-dark text-xl font-black mx-auto mobile-text-color">
        {t("screening.lead_screening_test")}
      </p>
      <div className="flex flex-col gap-2">
        {screeningResult?.events.map((e, index) => (
          <ScreeningEventCard index={index} screeningEvent={e} />
        ))}

        <ScreeningFaq />
      </div>
    </div>
  );
}
